
type LocaleInfo = {
  language: string;
  displayName: string;
  flag: string;
};

const LANGUAGE_FLAGS: Record<string, LocaleInfo> = {
  'en': {
    language: 'en',
    displayName: 'English',
    flag: '🇬🇧'
  },
  'fr': {
    language: 'fr',
    displayName: 'Français',
    flag: '🇫🇷'
  }
};

export const getLanguageFromLocale = (locale: string): string => {
  return locale.split('_')[0];
};

export const getLocaleInfo = (locale: string): LocaleInfo => {
  const language = getLanguageFromLocale(locale);
  return LANGUAGE_FLAGS[language] || LANGUAGE_FLAGS['en'];
};

export const isValidPrivacyType = (type: string): type is 'public' | 'private' => {
  return type === 'public' || type === 'private';
};
